<template>
  <div>
    <template v-if="parentModel === UserBucketItems.range.value">
      <div v-if="parentModel" class="segment-builder--item next-selection">
        <v-select
          v-model="rangeType"
          class="min-w-28"
          variant="outlined"
          persistentPlaceholder
          density="compact"
          hideDetails
          height="32px"
          :disabled="disabled"
          :items="rangeTypes"
          itemTitle="text"
          placeholder="Match Type"
          bgColor="#ffffff"
          @update:modelValue="(updateFilter(), resetChild())"
        />
      </div>
      <div v-if="rangeType !== null" class="segment-builder--item next-selection">
        <RfChevronIcon class="fill-beige-50 mx-1 my-auto h-6 w-6 rotate-180" />
        <RfCustomRangeSelector
          v-if="RangeTypesBase.range.value === rangeType"
          class="min-w-42"
          :modelValue="childModel"
          :disabled="disabled"
          minPlaceholder="0"
          maxPlaceholder="9999"
          @update:modelValue="updateChild"
        />
        <v-text-field
          v-else
          class="min-w-16"
          hideDetails
          persistentPlaceholder
          :modelValue="childModel?.[childModelIndex]"
          variant="outlined"
          density="compact"
          :disabled="disabled"
          placeholder="9999"
          bgColor="#ffffff"
          @update:modelValue="updateChild"
        />
      </div>
    </template>

    <template v-else-if="parentModel === UserBucketItems.values.value">
      <div class="segment-builder--item next-selection">
        <v-select
          v-model="negativeMatch"
          class="min-w-28"
          variant="outlined"
          persistentPlaceholder
          density="compact"
          hideDetails
          height="32px"
          :disabled="disabled"
          :items="matchTypeItems"
          itemTitle="text"
          placeholder="Match Type"
          bgColor="#ffffff"
          @update:modelValue="updateFilter"
        />
      </div>
      <div class="segment-builder--item next-selection">
        <RfChevronIcon class="fill-beige-50 mx-1 my-auto h-6 w-6 rotate-180" />
        <RfMultiChipInput
          v-model="userIds"
          class="min-w-48"
          :disabled="disabled"
          placeholder="User Ids"
          @update:modelValue="updateFilter"
        />
      </div>
    </template>
  </div>
</template>

<script setup>
import {
  MatchTypeItems,
  UserBucketItems,
  RangeTypesBase,
} from "@/utils/constants/SegmentsConstants";
import { computed, onMounted, ref } from "vue";
import RfCustomRangeSelector from "../RfCustomRangeSelector.vue";
import RfMultiChipInput from "@/components/RfMultiChipInput.vue";
import RfChevronIcon from "../icons/RfChevronIcon.vue";

const emit = defineEmits(["update:model"]);
const props = defineProps(["filter", "disabled"]);
const parentModel = ref(null);
const rangeType = ref(null);
const childModel = ref([]);
const rangeTypes = Object.values(RangeTypesBase);
const userIds = ref([]);
const matchTypeItems = Object.values(MatchTypeItems);
const negativeMatch = ref(null);
const childModelIndex = computed(
  () => +(rangeType.value === RangeTypesBase.less_than_or_equal_to.value),
);

const prepareFilter = () => {
  if (props.filter.user_bucket) {
    parentModel.value = UserBucketItems.range.value;
    childModel.value = props.filter.user_bucket[UserBucketItems.range.value];
    rangeType.value = props.filter.user_bucket.range_type;
  }
  if (props.filter.user_id) {
    parentModel.value = UserBucketItems.values.value;
    userIds.value = props.filter.user_id[UserBucketItems.values.value];
    negativeMatch.value = props.filter.user_id.negative_match;
  }
};

const getFilter = () => {
  if (parentModel.value === UserBucketItems.range.value)
    return {
      user_bucket: {
        [UserBucketItems.range.value]: childModel.value,
        range_type: rangeType.value,
      },
    };
  if (parentModel.value === UserBucketItems.values.value)
    return {
      user_id: {
        [UserBucketItems.values.value]: userIds.value,
        negative_match: negativeMatch.value,
      },
    };
  return {};
};

const updateFilter = () => {
  emit("update:model", getFilter());
};

const updateChild = v => {
  if (parentModel.value === UserBucketItems.range.value) {
    if (rangeType.value === RangeTypesBase.range.value) childModel.value = v;
    else if (rangeType.value === RangeTypesBase.equal_to.value) childModel.value = [v, v];
    else childModel.value.splice(childModelIndex.value, 1, v);
  }
  updateFilter();
};

const resetChild = () => {
  if (rangeType.value === RangeTypesBase.greater_than_or_equal_to.value)
    childModel.value = [null, "INF"];
  else if (rangeType.value === RangeTypesBase.less_than_or_equal_to.value)
    childModel.value = [0, null];
  else [null, null];
};

onMounted(prepareFilter);
</script>
